var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M11,7a4,4,0,1,0,4,4A4,4,0,0,0,11,7Zm8.94,3A9,9,0,0,0,12,2.06V0H10V2.06A9,9,0,0,0,2.06,10H0v2H2.06A9,9,0,0,0,10,19.94V22h2V19.94A9,9,0,0,0,19.94,12H22V10ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }